export const CUSTOM_ROUTE_PLACEHOLDERS = {
    postSlug: '**postSlug**',
};
//# sourceMappingURL=custom-route-placeholders.js.map